import React from 'react';
import styled from 'styled-components';


import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';


import '../assets/accordion.css';

import PhDependencyEnergyTool from '../components/phDependencyEnergyTool.js';


function phDependencyOfEnergy() {



  return (
    <div class="inner-section">
    <div class="container">
        <h3 class="header-title">PH Dependency of Energy</h3>
				<Accordion preExpanded={['a']}>
            <AccordionItem uuid="a">
                <AccordionItemHeading>
                    <AccordionItemButton>
                        PH Dependency of Energy
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <PhDependencyEnergyTool/>
                </AccordionItemPanel>
            </AccordionItem>


        </Accordion>

				<RefContactContainer>


					<ContactContainer>
						<Contact><b>Contact:</b> lli5@utep.edu</Contact>

					</ContactContainer>

				</RefContactContainer>


		 </div>

    </div>




  );
}


const Contact = styled.p`
    margin-top: 22px;
`;

const RefContactContainer = styled.div`
	display:flex;
	flex-direction: column;
  justify-content: space-between;
  align-items: center;
	margin-top:45px;
`;

const ContactContainer = styled.div`
	display: flex;
	flex-direction:row;
	font-family:"Fira Sans";
	justify-content:space-between;
	width: 100%;
	align-items:center;
`;








export default phDependencyOfEnergy;



// WEBPACK FOOTER //
// ./src/pages/phDependencyOfEnergy.js